/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gbp_TitleInputs */

const cs_integrations_gbp_title = /** @type {(inputs: Integrations_Gbp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Business Profile`)
};

const en_integrations_gbp_title = /** @type {(inputs: Integrations_Gbp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Business Profile`)
};

/**
* | output |
* | --- |
* | "Google Business Profile" |
*
* @param {Integrations_Gbp_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gbp_title = /** @type {((inputs?: Integrations_Gbp_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gbp_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gbp_title(inputs)
	return cs_integrations_gbp_title(inputs)
});